import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { SlingoConstants } from "../enum/SlingoConstants";
import { SymbolData } from "./SymbolData";
/*
 * SymbolConfigData.ts
 */
export class SymbolConfigData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    static getSymbol(id) {
        return this.symbols.getValue(id);
    }
    solidify() {
        super.solidify();
        this.solidifySymbols();
    }
    solidifySymbols() {
        let symbolConfig = this.data.getDataArray(SlingoConstants.PROPERTY_SYMBOL_CONFIG);
        if (symbolConfig) {
            for (let i = 0; i < symbolConfig.length; i++) {
                let symbol = new SymbolData(symbolConfig[i]);
                SymbolConfigData.symbols.setValue(symbol.getId(), symbol);
            }
        }
    }
    getSymbol(id) {
        return SymbolConfigData.getSymbol(id);
    }
    getSymbols() {
        return SymbolConfigData.symbols;
    }
}
SymbolConfigData.symbols = new Dictionary();
//# sourceMappingURL=SymbolConfigData.js.map